import { Route, Routes } from 'react-router-dom';

import { DashboardLayout } from '@/components/layout/dashboard-layout';
import { RequireAuth } from '@/components/require-auth';
import { ArtistDetailPage } from '@/pages/artist-detail';
import { ArtistsPage } from '@/pages/artists';
import { DashboardPage } from '@/pages/dashboard';
import { EmailsPage } from '@/pages/emails';
import { HelpPage } from '@/pages/help';
import { PrivacyPage, TermsPage } from '@/pages/legal';
import { LoginPage } from '@/pages/login';
import { MediaPage } from '@/pages/media';
import { MemberDetailPage } from '@/pages/member-detail';
import { NotFoundPage } from '@/pages/not-found';
import { NotificationsPage } from '@/pages/notifications';
import { ProjectDetailPage } from '@/pages/project-detail';
import { ProjectsPage } from '@/pages/projects';
import { ProposalDetailPage } from '@/pages/proposal-detail';
import { ProposalsPage } from '@/pages/proposals';
import { SettingsPage } from '@/pages/settings';
import { SubscribersPage } from '@/pages/subscribers';
import { VotesPage } from '@/pages/votes';
import { VotingPage } from '@/pages/voting';

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/terms" element={<TermsPage />} />
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route element={<RequireAuth />}>
        <Route element={<DashboardLayout />}>
          <Route index element={<DashboardPage />} />
          <Route path="projects" element={<ProjectsPage />} />
          <Route path="projects/:slug" element={<ProjectDetailPage />} />
          <Route path="artists" element={<ArtistsPage />} />
          <Route path="artists/:slug" element={<ArtistDetailPage />} />
          <Route path="proposals" element={<ProposalsPage />} />
          <Route path="proposals/:slug" element={<ProposalDetailPage />} />
          <Route path="media" element={<MediaPage />} />
          <Route path="voting" element={<VotingPage />} />
          <Route path="votes" element={<VotesPage />} />
          <Route path="notifications" element={<NotificationsPage />} />
          <Route path="subscribers" element={<SubscribersPage />} />
          <Route path="emails" element={<EmailsPage />} />
          <Route path="settings" element={<SettingsPage />} />
          <Route path="help" element={<HelpPage />} />
          <Route path="members/:id" element={<MemberDetailPage />} />
        </Route>
      </Route>
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
